function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  "data-name": "<Pfad>",
  d: "M7.56 52.8c-4.75-2.4-4.75-6.21 0-8.61L76.24 5.8c4.75-2.4 12.44-2.4 17.19 0l68.47 36.58c4.75 2.4 4.75 6.21 0 8.61L93.52 90.52c-4.75 2.4-12.42 2.4-17.16 0z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  "data-name": "<Pfad>",
  d: "M136.73 65.55v44.15c0 4.29-.7 4.75-4.59 8.22S108.64 140 84.73 140s-44.11-18.74-47.71-22.08-4.29-3.92-4.29-8.22V69.45c0-1.58 1.09-3.29 3.49-4.5l36-20.61"
});

var SvgStudent = function SvgStudent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "ICON",
    viewBox: "0 0 169.45 144",
    "aria-hidden": true
  }, props), _ref, _ref2);
};

export default SvgStudent;